import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import Invoice from './Invoice';
import MultiSelectionCheckbox from './MultiSelectionCheckbox';
var InvoiceTable = function InvoiceTable(_ref) {
  var allInvoices = _ref.allInvoices,
    allowsFapiaoProcessingAfterPayment = _ref.allowsFapiaoProcessingAfterPayment,
    enableSelection = _ref.enableSelection,
    invoices = _ref.invoices,
    onFapiaoCancelled = _ref.onFapiaoCancelled,
    selectedInvoiceNumbers = _ref.selectedInvoiceNumbers,
    updateSelections = _ref.updateSelections;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  if (invoices.length === 0) {
    return /*#__PURE__*/React.createElement("p", {
      className: "text-center"
    }, /*#__PURE__*/React.createElement(T, {
      source: "You do not have any invoices"
    }));
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "orders-container"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "orders-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "My Orders"
  })), /*#__PURE__*/React.createElement("p", {
    className: "orders-description"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.paddle-invoice-page-description"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-orders-table-wrapper"
  }, /*#__PURE__*/React.createElement("table", {
    className: "rubriq-orders-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, enableSelection ? /*#__PURE__*/React.createElement("th", {
    "aria-label": "invoice"
  }, /*#__PURE__*/React.createElement(MultiSelectionCheckbox, {
    invoices: allInvoices,
    updateSelections: updateSelections
  })) : null, /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Date')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Date"
  })), /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Invoice #')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Invoice #"
  })), /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Order #'),
    className: "d-none d-sm-table-cell"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Order #"
  })), /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Amount')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Amount"
  })), allowsFapiaoProcessingAfterPayment ? /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Fapiao')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Fapiao"
  })) : null, /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Actions'),
    className: "text-end"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Actions"
  })))), /*#__PURE__*/React.createElement("tbody", null, invoices.map(function (invoice) {
    return /*#__PURE__*/React.createElement(Invoice, {
      allowsFapiaoProcessingAfterPayment: allowsFapiaoProcessingAfterPayment,
      enableSelection: enableSelection,
      invoice: invoice,
      key: invoice.invoiceNumber,
      onFapiaoCancelled: onFapiaoCancelled,
      selected: selectedInvoiceNumbers.indexOf(invoice.invoiceNumber) !== -1,
      updateSelections: updateSelections
    });
  }))))));
};
export default InvoiceTable;